export default "__VITE_ASSET__694cd188__"